import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { TranslationsLoadedService } from '../services/translations-loaded.service';

export const ENVIRONMENT = {
    production: true,
    apiUrl: '',
    wsUrl: ''
};

export function loadEnvironment(http: HttpClient, translationsLoaded: TranslationsLoadedService): Promise<void> {
    return Promise.all([
        firstValueFrom(http.get('/assets/config.json')),
        firstValueFrom(translationsLoaded.isLoaded)
    ]).then(
        ([config, _]) => {
            Object.assign(ENVIRONMENT, (config as any).find((e: any) => e.production));
        }
    );
}

